export default __webpack_public_path__ + "static/media/le_mont4.69eae847.jpg";